import { render, staticRenderFns } from "./ViewDetailsMain.vue?vue&type=template&id=544e2309"
import script from "./ViewDetailsMain.vue?vue&type=script&lang=js"
export * from "./ViewDetailsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports